// extracted by mini-css-extract-plugin
export default {"cls1":"common-cls1___e194b61efc3fdf405ee","cls2":"common-cls2__f3ed8da2c86b51dd1a52 common-cls1___e194b61efc3fdf405ee"};